import { withNestedView } from '@/router/routerHelpers';
import { PERMISSIONS } from '@/access/permissions';
import { FEATURES } from '@/access/features';
const loadView = withNestedView('contacts');

const contactsRoutes = [
  {
    path: '/contacts',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '',
        meta: { showNav: true },
        component: loadView('Contacts'),
        children: [
          {
            path: '',
            name: 'contacts-main',
            component: loadView('ContactsMain'),
          },
          {
            path: 'archived',
            name: 'contacts-archived',
            component: loadView('ContactsMain'),
            props: {
              archived: true,
            },
            meta: {
              feature: FEATURES.CONTACTS_ARCHIVED,
            },
          },
          {
            path: 'notes',
            name: 'contacts-notes',
            component: loadView('notes/ContactsNotes'),
            meta: {
              feature: FEATURES.CONTACTS_NOTES,
            },
          },
          {
            path: 'tasks',
            name: 'contacts-tasks',
            meta: {
              feature: FEATURES.CONTACTS_TASKS,
            },
            component: loadView('tasks/ContactsTasks'),
          },
          {
            path: 'views',
            name: 'contacts-views',
            component: loadView('views/Views'),
          },
        ],
      },
      {
        path: 'views/new',
        redirect: { name: 'contacts-views' },
      },
      {
        path: 'views/:id',
        name: 'contacts-view',
        props: true,
        component: loadView('views/View'),
      },

      {
        path: 'create',
        name: 'contact-create',
        props: true,
        component: loadView('contact/ContactCreate'),
      },
      {
        path: 'import',
        name: 'contacts-import',
        props: true,
        component: loadView('import/ContactsImportView'),
      },
      {
        path: 'import/status/:importId',
        name: 'contacts-import-status',
        props: true,
        component: loadView('import/ContactsImportStatusView'),
      },
      {
        path: 'boards',
        name: 'contacts-boards',
        props: true,
        meta: {
          feature: FEATURES.CONTACTS_BOARDS,
        },
        component: loadView('boards/ContactsBoards'),
      },
      {
        path: 'relationships',
        name: 'contacts-relationships',
        props: true,
        meta: {
          permission: PERMISSIONS.CONTACTS_RELATIONSHIPS,
        },
        component: loadView('relationships/ContactsRelationships'),
      },
      {
        path: ':id',
        name: 'contact-edit',
        props: true,
        component: loadView('contact/ContactPage'),
      },
    ],
  },
];

export default contactsRoutes;
